import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import createComponent1 from './assets/images/create-component1.png';
import createComponent2 from './assets/images/create-component2.png';
import reactHello from './assets/images/react-hello.png';


const ReactLesson5 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      import React, { Component } from 'react';   

      class App extends Component {
        render(){
          return{
            <div>
            <h1>Hello World! </h1>
            </div>
          }
        }
      }

      export default App;
      `
    );
    const code1 = (
      'text',
      `
      import React from 'react';   

      const App =  () => {
          return{
            <div>
            <h1>Hello World! </h1>
            </div>
          }
        }

      export default App;
      `
    );

  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>What is a Component</strong></h3>
      <p>A component in React is a reusable construction unit that contains the logic and elements of a portion of the user interface. The fundamental building blocks that organize and depict various UI elements in a React application are called components. They enable programmers to write maintainable, reusable, and modular code.</p>
     <h4 class="text-dark">Characteristics of React Components:</h4>
     <ol class="list-group list-group-numbered mb-4">
        <li class="list-group-item"><strong>Modularity:</strong>Code management and organization are made simpler by components, which encapsulate particular UI elements.</li>
        <li class="list-group-item"><strong>Reusability:</strong>Components can be reused throughout an application, allowing developers to build complex interfaces from smaller, self-contained pieces.</li>
        <li class="list-group-item"><strong>Composability:</strong>React components can be composed together, allowing for the creation of larger components by combining smaller ones.</li>
        <li class="list-group-item"><strong>Encapsulation:</strong>Components can contain their own state, properties (props), and methods, encapsulating logic and data within themselves.</li>
     </ol>
     <h3><strong>Types of Components in React</strong></h3>
     <ol class="list-group list-group-numbered mb-4">
         <li class="list-group-item"><strong>Class Components:</strong> These are ES6 classes that extend React.Component. They include a <strong><em>render()</em></strong> method that returns JSX. Class components have additional features like local state and lifecycle methods, making them suitable for more complex logic.</li>
         <li class="list-group-item"><strong>Functional Components:</strong> These are JavaScript functions that return JSX, describing the UI. They are simpler, easier to read, and commonly used for presentational components. React 16.8 introduced <strong>React Hooks</strong> for Functional components and brought features which were previously reserved for class components to Functional components.</li>
     </ol>
     <h3><strong>Which One Should I Use?</strong></h3>
     <p>Here's a statement from the React Website:</p>
     <blockquote>Class components are still supported by React, but we don't recommend using them in new code.</blockquote>
     <p>It's all right to learn about class components because you might find yourself working on some legacy React codebase or maybe you want to implement error boundaries. But if you are creating a new React project, use Functional components.</p>
     <p>We shall see how to create these 2 types of components in our next lesson.</p><br/>
     <p>We are going to create a class and functional component that prints <strong>Hello World</strong></p>
  
  <ol class="list-group list-group-numbered mb-4">
      <li class="list-group-item"><strong>Class Component</strong>
      <ol>
      <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />       </ol>
      </li>
      <li class="list-group-item"><strong>Function Component</strong>
      <ol>
      <CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />  
                      
                      

                           </ol>
      </li>
  </ol>
  <h4><strong>Result</strong></h4>
  <img className="responsive img-fluid mb-4" src={reactHello} alt="react" />
  <p>You can notice that in the functional component there's no need for the render method, but both have the default statement. </p>
  <h3><strong>Summary</strong></h3>
  <p>These examples showcase how to create basic React components using functional and class-based approaches. Components are the building blocks of React applications, and they can be used to create complex user interfaces.</p>
  

  
    </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson5